// URL prefill from calculator / mini widget (?valoare=5000&durata=36)
(function () {
	const params = new URLSearchParams(window.location.search);

	const valoare = params.get('valoare');

	if (valoare) {
		const el = document.querySelector('[data-grenke-prefill="valoare"]');

		if (el) {
			el.value = valoare;
			el.classList.add('is-filled');
		}
	}

	const durata = params.get('durata');

	if (durata) {
		const el = document.querySelector('[data-grenke-prefill="durata"]');

		if (el) {
			const digits = String(durata).replace(/\D/g, '');
			const candidates = [durata, digits, `${digits} luni`];

			Array.from(el.options).forEach((opt) => {
				if (candidates.includes(opt.value)) opt.selected = true;
			});
			el.classList.add('is-filled');
		}
	}
})();

if (!customElements.get('grenke-product-picker')) {
	class GrenkeProductPicker extends HTMLElement {
		connectedCallback() {
			this._searchInput = this.querySelector('.grenke-products__search-input');
			this._resultsList = this.querySelector('.grenke-products__results');
			this._qtyInput = this.querySelector('.grenke-products__qty');
			this._addBtn = this.querySelector('.grenke-products__add-btn');
			this._listWrap = this.querySelector('.grenke-products__list');
			this._tbody = this.querySelector('.grenke-products__tbody');
			this._totalEl = this.querySelector('.grenke-products__total');
			this._hiddenData = this.querySelector('.grenke-products__data');
			this._valoareInput = document.querySelector('[data-grenke-prefill="valoare"]');

			this._selected = null;
			this._rows = [];
			this._timer = null;
			this._abortController = null;

			this._onDocumentClick = (e) => {
				if (!this.contains(e.target)) this._hideResults();
			};

			this._searchInput.addEventListener('input', () => this._onSearchInput());
			this._searchInput.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') this._hideResults();
			});
			this._addBtn.addEventListener('click', () => this._addRow());
			document.addEventListener('click', this._onDocumentClick);

			this._prefillFromUrl();
		}

		_prefillFromUrl() {
			const params = new URLSearchParams(window.location.search);
			const title = params.get('product');
			if (!title) return;
			const price = parseFloat(params.get('product_price')) || 0;
			const qty = Math.max(1, parseInt(params.get('product_qty'), 10) || 1);
			this._rows.push({ title, qty, price });
			this._renderTable();
		}

		disconnectedCallback() {
			document.removeEventListener('click', this._onDocumentClick);
			this._abortController?.abort();
		}

		_onSearchInput() {
			clearTimeout(this._timer);
			const q = this._searchInput.value.trim();

			if (q.length < 2) {
				this._hideResults();
				return;
			}

			this._timer = setTimeout(() => this._fetchResults(q), 220);
		}

		async _fetchResults(q) {
			this._abortController?.abort();
			this._abortController = new AbortController();

			try {
				const res = await fetch(
					`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`,
					{ signal: this._abortController.signal },
				);
				const data = await res.json();

				this._renderResults(data?.resources?.results?.products || []);
			} catch (err) {
				if (err.name === 'AbortError') return;
				this._hideResults();
			}
		}

		_renderResults(products) {
			this._resultsList.innerHTML = '';
			if (!products.length) {
				this._hideResults();
				return;
			}

			products.forEach((p) => {
				const price = parseFloat(p.price) || 0;
				const imgUrl = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image?.url;
				const li = document.createElement('li');

				li.className = 'grenke-products__result-item';
				li.setAttribute('role', 'option');
				li.innerHTML = `
          ${imgUrl ? `<img src="${imgUrl}" alt="" width="36" height="36" loading="lazy">` : ''}
          <span class="grenke-products__result-title">${p.title}</span>
          <span class="grenke-products__result-price">${this._fmt(price)} RON</span>
        `;
				li.addEventListener('mousedown', (e) => {
					e.preventDefault();
					this._selected = { title: p.title, price };
					this._searchInput.value = p.title;
					this._hideResults();
					this._addRow();
				});
				this._resultsList.appendChild(li);
			});
			this._resultsList.hidden = false;
		}

		_hideResults() {
			this._resultsList.hidden = true;
			this._resultsList.innerHTML = '';
		}

		_addRow() {
			const customTitle = this._searchInput.value.trim();

			if (!this._selected && !customTitle) {
				this._searchInput.focus();
				return;
			}

			const qty = Math.max(1, parseInt(this._qtyInput.value, 10) || 1);

			this._rows.push({
				title: this._selected?.title || customTitle,
				qty,
				price: this._selected?.price || 0,
			});
			this._selected = null;
			this._searchInput.value = '';
			this._qtyInput.value = '1';
			this._renderTable();
		}

		_renderTable() {
			this._tbody.innerHTML = '';
			this._rows.forEach((row, i) => {
				const rowTotal = row.qty * row.price;
				const tr = document.createElement('tr');

				tr.innerHTML = `
          <td class="grenke-products__cell-name">${row.title}</td>
          <td><input type="number" class="grenke-products__row-qty" value="${row.qty}" min="1" max="999" aria-label="Cantitate"></td>
          <td class="grenke-products__cell-num">${this._fmt(row.price)}</td>
          <td class="grenke-products__cell-num">${this._fmt(rowTotal)}</td>
          <td><button type="button" class="grenke-products__remove" aria-label="Șterge">&times;</button></td>
        `;
				tr.querySelector('.grenke-products__row-qty').addEventListener('change', (e) => {
					this._rows[i].qty = Math.max(1, parseInt(e.target.value, 10) || 1);
					this._renderTable();
				});
				tr.querySelector('.grenke-products__remove').addEventListener('click', () => {
					this._rows.splice(i, 1);
					this._renderTable();
				});
				this._tbody.appendChild(tr);
			});

			const grandTotal = this._rows.reduce((s, r) => s + r.qty * r.price, 0);

			this._totalEl.textContent = `${this._fmt(grandTotal)} RON`;
			this._listWrap.hidden = this._rows.length === 0;

			if (this._valoareInput && grandTotal > 0) {
				this._valoareInput.value = Math.round(grandTotal);
				this._valoareInput.classList.add('is-filled');
				this._valoareInput.dataset.grenkeAutofilled = '1';
			} else if (this._valoareInput && grandTotal === 0) {
				const prefilled = new URLSearchParams(window.location.search).get('valoare');

				if (!prefilled) {
					this._valoareInput.value = '';
					this._valoareInput.classList.remove('is-filled');
					this._valoareInput.dataset.grenkeAutofilled = '';
				}
			}

			if (this._hiddenData) {
				if (this._rows.length) {
					const lines = this._rows.map(
						(r) =>
							`${r.qty}x ${r.title} — ${this._fmt(r.price)} RON/buc = ${this._fmt(r.qty * r.price)} RON`,
					);

					lines.push(`---\nTotal estimat: ${this._fmt(grandTotal)} RON`);
					this._hiddenData.value = lines.join('\n');
				} else {
					this._hiddenData.value = '';
				}
			}

			this.dispatchEvent(new CustomEvent('grenke:rows-changed', { bubbles: true }));
		}

		_fmt(n) {
			return (n || 0).toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
		}
	}

	customElements.define('grenke-product-picker', GrenkeProductPicker);
}

(function wireGrenkeForm() {
	const form = document.getElementById('grenke-contact-form');

	if (!form) return;

	const GADGET_URL = form.dataset.gadgetUrl || '';
	const GADGET_SECRET = form.dataset.gadgetSecret || '';

	const DRAFT_KEY = 'grenke_form_draft';
	const DRAFT_TTL = 3 * 24 * 60 * 60 * 1000;
	let _saveTimer = null;

	function saveDraft() {
		const picker = form.querySelector('grenke-product-picker');
		try {
			localStorage.setItem(
				DRAFT_KEY,
				JSON.stringify({
					ts: Date.now(),
					companie: form.querySelector('[name="companie"]')?.value || '',
					cui: form.querySelector('[name="cui"]')?.value || '',
					contactName: form.querySelector('[name="contactName"]')?.value || '',
					telefon: form.querySelector('[name="telefon"]')?.value || '',
					email: form.querySelector('[name="email"]')?.value || '',
					valoare: form.querySelector('[name="valoare"]')?.value || '',
					durata: form.querySelector('[name="durata"]')?.value || '',
					mesaj: form.querySelector('[name="mesaj"]')?.value || '',
					products: picker?._rows || [],
				}),
			);
		} catch (_) {}
	}

	function scheduleSave() {
		clearTimeout(_saveTimer);
		_saveTimer = setTimeout(saveDraft, 600);
	}

	function loadDraft() {
		try {
			const raw = localStorage.getItem(DRAFT_KEY);
			if (!raw) return;
			const draft = JSON.parse(raw);
			if (!draft.ts || Date.now() - draft.ts > DRAFT_TTL) {
				localStorage.removeItem(DRAFT_KEY);
				return;
			}
			['companie', 'cui', 'contactName', 'telefon', 'email', 'valoare', 'mesaj'].forEach((name) => {
				if (!draft[name]) return;
				const el = form.querySelector(`[name="${name}"]`);
				if (!el || el.value) return;
				el.value = draft[name];
				el.classList.add('is-filled');
			});
			if (draft.durata) {
				const sel = form.querySelector('[name="durata"]');
				if (sel && !sel.value) {
					Array.from(sel.options).forEach((o) => {
						if (o.value === draft.durata) o.selected = true;
					});
				}
			}
			if (draft.products?.length) {
				const picker = form.querySelector('grenke-product-picker');
				if (picker && picker._rows?.length === 0) {
					picker._rows = draft.products;
					picker._renderTable();
				}
			}
		} catch (_) {}
	}

	loadDraft();

	form.addEventListener('input', scheduleSave);
	form.addEventListener('change', scheduleSave);
	form.addEventListener('grenke:rows-changed', scheduleSave);

	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		const submitBtn = form.querySelector('[data-grenke-submit]');
		const successEl = form.querySelector('[data-grenke-success]');
		const errorEl = form.querySelector('[data-grenke-error]');

		if (!GADGET_URL || !GADGET_SECRET) {
			if (errorEl) {
				errorEl.querySelector('.banner__content').textContent =
					'Configurare lipsă. Contactați administratorul site-ului.';
				errorEl.style.display = '';
			}
			return;
		}

		if (submitBtn) submitBtn.disabled = true;
		if (errorEl) errorEl.style.display = 'none';
		if (successEl) successEl.style.display = 'none';

		const fd = new FormData(form);
		const payload = {
			companie: fd.get('companie') || '',
			cui: fd.get('cui') || '',
			contactName: fd.get('contactName') || '',
			telefon: fd.get('telefon') || '',
			email: fd.get('email') || '',
			produse: fd.get('produse') || '',
			valoare: fd.get('valoare') || '',
			durata: fd.get('durata') || '',
			mesaj: fd.get('mesaj') || '',
			recipientEmail: form.dataset.recipientEmail || '',
		};

		try {
			const res = await fetch(GADGET_URL, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'x-grenke-secret': GADGET_SECRET },
				body: JSON.stringify(payload),
			});

			if (!res.ok) throw new Error(`HTTP ${res.status}`);

			if (successEl) successEl.style.display = 'flex';
			localStorage.removeItem(DRAFT_KEY);
			form.reset();
			form.querySelectorAll('.is-filled').forEach((el) => el.classList.remove('is-filled'));
			const picker = form.querySelector('grenke-product-picker');
			if (picker) {
				picker._rows = [];
				picker._renderTable();
			}
		} catch (err) {
			if (errorEl) errorEl.style.display = '';
		} finally {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.removeAttribute('aria-busy');
			}
		}
	});
})();
